import { render, staticRenderFns } from "./MedicineCabinetList.vue?vue&type=template&id=706b8d22&scoped=true&lang=pug&"
import script from "./MedicineCabinetList.vue?vue&type=script&lang=ts&"
export * from "./MedicineCabinetList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706b8d22",
  null
  
)

export default component.exports